import React from "react";
import { Box, Typography, Chip } from "@mui/material";

export const MySelectedProductCats = ({ items }) => {
  if (!items || items.length === 0) return null;

  // 1. Check the first item to determine the display logic
  const firstItem = items[0];
  const isSimpleList = !firstItem.Category && !firstItem.SubCategory;

  // 2. If only one key (MainCategory) is populated, show a highly compact list
  if (isSimpleList) {
    return (
      <Box display="flex" flexWrap="wrap" gap={1}>
        {items.map((item, index) => (
          <Chip
            key={index}
            label={item.MainCategory || "Unknown"}
            variant="outlined"
            size="small"
          />
        ))}
      </Box>
    );
  }

  // 3. Otherwise, proceed with the grouped display for nested categories
  const groupedItems = items.reduce((acc, item) => {
    const mainCategory = item.MainCategory || "Unknown";
    if (!acc[mainCategory]) {
      acc[mainCategory] = [];
    }
    acc[mainCategory].push(item);
    return acc;
  }, {});

  const getCategoryLabel = (item) => {
    if (item.SubCategory) return item.SubCategory;
    if (item.Category) return item.Category;
    return item.MainCategory;
  };

  return (
    <Box>
      {Object.entries(groupedItems).map(([mainCategory, itemsInGroup]) => (
        <Box
          key={mainCategory}
          mb={1.5} // Reduced from 2 for a more compact display
          p={1.5} // Reduced from 2 for a more compact display
          border="1px solid #e0e0e0"
          borderRadius="8px"
          bgcolor="#fafafa"
        >
          <Typography variant="subtitle2" color="text.primary" gutterBottom>
            {mainCategory}
          </Typography>
          <Box display="flex" flexWrap="wrap" gap={1}>
            {itemsInGroup.map((item, index) => (
              <Chip
                key={index}
                label={getCategoryLabel(item)}
                variant="outlined"
                size="small"
              />
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};
